export function menuInfoSet (list, arg) {
  console.log(list);
  let arr = []
  let cashier = [];
  let shopMenu = [];
  let cashierMenuFlag = false;
  let shopMenuFlag = false;
  for (let i in list) {
    if (list[i].categoryId == "1") {
      cashierMenuFlag = true;
      for (let j in list[i].menuList) {
        if (list[i].menuList[j].code == "createOrder") {
          list[i].menuList[j].url = "/collectMoney/productFootBath"
        }
        if (list[i].menuList[j].code == "cardCreate") {
          list[i].menuList[j].url = "/collectMoney/openCard"
        }
        if (list[i].menuList[j].code == "repairCreate") {
          list[i].menuList[j].url = "/collectMoney/paperRepair"
        }
        if (list[i].menuList[j].code == "reserve") {
          list[i].menuList[j].url = "/collectMoney/reserveInfo"
        }
        if (list[i].menuList[j].code == "cardReduce") {
          list[i].menuList[j].url = "/collectMoney/paddleCard"
        }
        if (list[i].menuList[j].code == "repairDoc") {
          list[i].menuList[j].url = "/collectMoney/paperRepair/edit"
        }
        if (list[i].menuList[j].code == "paperCard") {
          list[i].menuList[j].url = "/collectMoney/paperCard"
        }
        if (list[i].menuList[j].code == "memberRecharge") {
          list[i].menuList[j].url = "/collectMoney/memberRecharge"
        }
        if (list[i].menuList[j].code == "icCard") {
          list[i].menuList[j].url = "/collectMoney/icCard"
        }
        if (list[i].menuList[j].code == "thirdOrder") {
          list[i].menuList[j].url = "/collectMoney/thirdOrder"
        }
        if (list[i].menuList[j].code == "memberLogout") {
          list[i].menuList[j].url = "/collectMoney/memberLogout"
        }
      }
      cashier = list[i].menuList;
      localStorage.setItem("cashierMenu", JSON.stringify(cashier))
    }

    if (list[i].categoryId == "2") {
      shopMenuFlag=true;
      for (let j in list[i].menuList) {
        if (list[i].menuList[j].code == "staffManage") {
          list[i].menuList[j].url = "/manage/staffManage"
        }
        if (list[i].menuList[j].code == "invoice") {
          list[i].menuList[j].url = "/manage/invoice"
        }
        if (list[i].menuList[j].code == "repairAudit") {
          list[i].menuList[j].url = "/manage/repairAudit"
        }
        if (list[i].menuList[j].code == "orderInvaild") {
          list[i].menuList[j].url = "/manage/cancellation"
        }
        if (list[i].menuList[j].code == "shopRefund") {
          list[i].menuList[j].url = "/manage/orderRefund"
        }
        if (list[i].menuList[j].code == "shopRecharge") {
          list[i].menuList[j].url = "/manage/shopRecharge"
        }
        if (list[i].menuList[j].code == "companyLeave") {
          list[i].menuList[j].url = "/dataList/companyLeave"
        }
        if (list[i].menuList[j].code == "shopGift") {
          list[i].menuList[j].url = "/manage/shopGift"
        }
        if (list[i].menuList[j].code == "staffTransfer") {
          list[i].menuList[j].url = "/manage/staffTransfer"
        }
        if (list[i].menuList[j].code == "fundtransfer") {
          list[i].menuList[j].url = "/manage/fundtransfer"
        }
        if (list[i].menuList[j].code == "shopServe") {
          list[i].menuList[j].url = "/manage/shopServe"
        }
      }
      shopMenu = list[i].menuList;
      localStorage.setItem("shopMenu", JSON.stringify(shopMenu))
    }

    if (list[i].categoryId == "3") {
      for (let j in list[i].menuList) {
        if (list[i].menuList[j].code == "businessData") {
          list[i].menuList[j].url = "/dataList/data"
        }
        if (list[i].menuList[j].code == "shopData") {
          list[i].menuList[j].url = "/dataList/shopData"
        }
        if (list[i].menuList[j].code == "achievement") {
          list[i].menuList[j].url = "/dataList/achievement"
        }
        if (list[i].menuList[j].code == "collectRank") {
          list[i].menuList[j].url = "/dataList/collectRank"
        }
        if (list[i].menuList[j].code == "memberCardTrade") {
          list[i].menuList[j].url = "/dataList/memberCardTrade"
        }
        if (list[i].menuList[j].code == "packCardTrade") {
          list[i].menuList[j].url = "/dataList/packCardTrade"
        }
        if (list[i].menuList[j].code == "reportElectronMember") {
          list[i].menuList[j].url = "/dataList/reportElectronMember"
        }
        if (list[i].menuList[j].code == "saleTarget") {
          list[i].menuList[j].url = "/dataList/salesTarget"
        }
        if (list[i].menuList[j].code == "integralAchievement") {
          list[i].menuList[j].url = "/dataList/integralAchievement"
        }
        if (list[i].menuList[j].code == "repairData") {
          list[i].menuList[j].url = "/dataList/repairData"
        }
        if (list[i].menuList[j].code == "dailyBusiness") {
          list[i].menuList[j].url = "/dataList/dailyBusiness"
        }
        if (list[i].menuList[j].code == "yuanYuanAchievement") {
          list[i].menuList[j].url = "/dataList/yuanYuanAchievement"
        }
        if (list[i].menuList[j].code == "memberDataAnalysis") {
          list[i].menuList[j].url = "/dataList/memberDataAnalysis"
        }
      }
      arr = arr.concat(list[i].menuList);
    }

    if (list[i].categoryId == "4") {
      for (let j in list[i].menuList) {
        if (list[i].menuList[j].code == "salary") {
          list[i].menuList[j].url = "/dataList/salary"
        }
        if (list[i].menuList[j].code == "staffKPISalary") {
          list[i].menuList[j].url = "/dataList/staffKPISalary"
        }
        if (list[i].menuList[j].code == "shopBill") {
          list[i].menuList[j].url = "/dataList/shopBill"
        }
        if (list[i].menuList[j].code == "staffSubsidy") {
          list[i].menuList[j].url = "/dataList/staffSubsidy"
        }
        if (list[i].menuList[j].code == "cookAllowance") {
          list[i].menuList[j].url = "/dataList/cookAllowance"
        }
      }
      arr = arr.concat(list[i].menuList);
    }

    if (list[i].categoryId == "5") {
      for (let j in list[i].menuList) {
        if (list[i].menuList[j].code == "integralOrder") {
          list[i].menuList[j].url = "/dataList/integralOrder"
        }
        if (list[i].menuList[j].code == "deposit") {
          list[i].menuList[j].url = "/dataList/productDeposit"
        }
        if (list[i].menuList[j].code == "staffBorrowInfo") {
          list[i].menuList[j].url = "/dataList/staffBorrowInfo"
        }
        if (list[i].menuList[j].code == "attendancePunch") {
          list[i].menuList[j].url = "/dataList/attendancePunch"
        }
        if (list[i].menuList[j].code == "customerInfo") {
          list[i].menuList[j].url = "/dataList/smsTemplate"
        }
        if (list[i].menuList[j].code == "staffJournal") {
          list[i].menuList[j].url = "/dataList/staffJournal"
        }
        if (list[i].menuList[j].code == "inventory") {
          list[i].menuList[j].url = "/dataList/inventory"
        }
        if (list[i].menuList[j].code == "memberDataAlert") {
          list[i].menuList[j].url = "/dataList/memberDataAlert"
        }
      }
      arr = arr.concat(list[i].menuList);
    }

    if (list[i].categoryId == "7") {
      for (let j in list[i].menuList) {
        if (list[i].menuList[j].code == "inventoryInquire") {
          list[i].menuList[j].url = "/dataList/inventoryInquire"
        }
      }
      arr = arr.concat(list[i].menuList);
    }

    if (list[i].categoryId == "6") {
      for (let j in list[i].menuList) {
        if (list[i].menuList[j].code == "paperCardInput") {
          list[i].menuList[j].url = "/dataList/paperSetMeal"
        }
        if (list[i].menuList[j].code == "repairCard") {
          list[i].menuList[j].url = "/dataList/paperTable"
        }
        if (list[i].menuList[j].code == "electronPackage") {
          list[i].menuList[j].url = "/dataList/packAge"
        }
        if (list[i].menuList[j].code == "deduct") {
          list[i].menuList[j].url = "/dataList/deductTable"
        }
      }
      arr = arr.concat(list[i].menuList);
    }
    
    localStorage.setItem("dataMenu", JSON.stringify(arr))
    if (!cashierMenuFlag && arg) {
      localStorage.removeItem("cashierMenu")
    }
    if (!shopMenuFlag && arg) {
      localStorage.removeItem("shopMenu")
    }
  }
}